import React, { useState } from 'react';
import Select from 'react-select';


const Dropdown = ({ options, clearable, disabled, isMulti, customStyle, value, setValue, placeholder, label, errorFields, name }) => {

    let style = customStyle || {}

    const errorMessage = errorFields.find(r => r.name === name) && errorFields.find(r => r.name === name).message

    return (<div className='input-container'>
        <label style={{ display: 'flex', marginTop: '15px', marginBottom: '5px', fontWeight: '500', fontSize: '16px', color: '#5E5E5E' }}>{label || ''}</label>
        <Select
            isMulti={!!isMulti}
            isDisabled={disabled}
            className={errorFields.map(({ name }) => name).includes(name) ? 'basic-single-error' : "basic-single"}
            classNamePrefix="select"
            isClearable={!!clearable}
            placeholder={placeholder || ''}
            value={value}
            options={options.map(v => ({ label: v, value: v }))}
            onChange={setValue}
        />
        {errorMessage && <p style={{ margin: 0, fontWeight: '500', fontSize: '15px', color: '#D90000' }}>{errorMessage}</p>}

    </div>)
}

export default Dropdown